﻿
import { ESignClient, type FileResponse, type AxiosResponse } from './esignclient';

export class ESignClient2 extends ESignClient {
  // As the generated client doesn't support the filename* extension field for Unicode filenames and instead only uses the filename non-Unicode field, preprocess to copy the filename* field to the filename field
  protected processDownloadAttachmentGET(response: AxiosResponse): Promise<FileResponse> {
    const contentDisposition = response.headers['content-disposition'];
    const fileNameStarMatch = contentDisposition ? /filename\*=[^']*'[^']*'(.*)/g.exec(contentDisposition) : undefined;
    const fileNameStar = fileNameStarMatch && fileNameStarMatch.length > 1 ? decodeURIComponent(fileNameStarMatch[1]) : undefined;
    if (fileNameStar) {
      response.headers['content-disposition'] = contentDisposition.replace(/filename=.*/, 'filename="' + fileNameStar + '"');
    }
    return super.processDownloadAttachmentGET(response);
  }
}
